export default __webpack_public_path__ + "static/media/ellipse.83ac3eae.svg";